import { navItemsActionTypes } from "../actions/navItems.actions";

// Helper function to sanitize token
const sanitizeToken = (token) => {
  // Return null for invalid tokens
  if (!token || token === "null" || token === "" || typeof token !== 'string' || token.trim().length < 10) {
    return null;
  }
  return token;
};

export default function navItemsReducer(state = null, action) {
  // Sanitize token on state rehydration (Redux Persist)
  if (state && state.token) {
    const sanitizedToken = sanitizeToken(state.token);
    if (sanitizedToken !== state.token) {
      state = {
        ...state,
        token: null,
        isAuth: false,
        userType: null,
        mtUser: null
      };
    }
  }
  
  switch (action.type) {
    case navItemsActionTypes.FETCH_NAV_ITEMS_DATA_SUCCESS:
      if (action.isAuth) {
        return { ...state, authenticatedNav: action.data };
      } else {
        return { ...state, anonymousNav: action.data };
      }

    case navItemsActionTypes.VALIDATE_TOKEN_SUCCESS:
      return {
        ...state,
        isAuth: action.isAuth === true ? true : false,
        token: sanitizeToken(action.token),
        userType: action.isAuth === true ? action.userType : null,
        changePasswordRequired: action.changePasswordRequired || false,
        mtUser: action.isAuth === true ? action.mtUser : null,
        // Keep the last known value when this dispatch didn't carry one (e.g. change-password flow),
        // instead of wiping out what login already set.
        ttSecondOrderStatus:
          action.isAuth === true
            ? action.ttSecondOrderStatus !== undefined
              ? action.ttSecondOrderStatus
              : state?.ttSecondOrderStatus ?? null
            : null
      };

    case navItemsActionTypes.CHANGE_PASSWORD_TOKEN_SUCCESS:
      return {
        ...state,
        isAuth: action.isAuth,
        token: action.token,
      };

    case navItemsActionTypes.CUSTOMER_ARCHIVE_SUCCESS:
      return { 
        ...state, 
        archiveData: action.data 
      };

    case navItemsActionTypes.CONFIGURATION_SUCCESS:
      return {
        ...state,
        configData: action.data
      };

    case navItemsActionTypes.SET_TT_SECOND_ORDER_STATUS:
      return {
        ...state,
        ttSecondOrderStatus: action.status
      };

    case navItemsActionTypes.SET_SOLD_TO_NUMBER:
      return {
        ...state,
        soldToNumber: action.soldToNumber
      };

    default:
      return state;
  }
}
